import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "poster", "modal"]
  static values = {
    urls: Array
  }

  connect() {
    if (this.hasUrlsValue && this.urlsValue.length > 0) {
      this.generateCover(this.urlsValue)
    }
  }

  generateCover(imageUrls) {
    const cover = this.containerTarget

    if (imageUrls.length === 1) {
      cover.className = 'w-full h-full'
      this.setBackgroundImage(cover, imageUrls[0])
    } else {
      cover.innerHTML = ''
      const wrapper = this.createDiv('w-full h-full flex')
      cover.appendChild(wrapper)

      imageUrls.forEach(url => {
        const half = this.createDiv('flex w-full h-full')
        this.setBackgroundImage(half, url)
        wrapper.appendChild(half)
      })
    }
  }

  openPosterModal() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove('opacity-0', 'pointer-events-none')
      document.body.style.overflow = 'hidden'
    }
  }

  closePosterModal() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.add('opacity-0', 'pointer-events-none')
      document.body.style.overflow = ''
    }
  }

  createDiv(className) {
    const div = document.createElement('div')
    div.className = className
    return div
  }

  setBackgroundImage(element, url) {
    element.style = `
      background-image: url("${url}");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    `
  }
}
